import type { PageType } from '@/types';
import { mixpanelTrack } from '@/utils/mixpanelUtils/asyncMixpanel';
import {
  type MixpanelEvent,
  type MixpanelEventProps,
  RevenueDashboardWidget,
} from '@/utils/mixpanelUtils/events';
import { CONTENT_PERFORMANCE_PAGE } from '@/utils/constants';

/**
 * Fires a Mixpanel event only when the current page is the content performance page.
 * Shared by any widget on this page (chart controls, level tabs, etc.) so the
 * page-guard lives in one place; defaults to the chart widget for existing call sites.
 */
export const trackContentPerformanceEventIfApplicable = <T extends MixpanelEvent>(
  page: PageType | undefined,
  event: T,
  payload: Omit<MixpanelEventProps<T>, 'page' | 'widget'>,
  widget: RevenueDashboardWidget = RevenueDashboardWidget.ContentPerformanceChart
): void => {
  if (page !== CONTENT_PERFORMANCE_PAGE) {
    return;
  }
  void mixpanelTrack(event, {
    widget,
    page: CONTENT_PERFORMANCE_PAGE,
    ...payload,
  } as MixpanelEventProps<T>);
};
